"use strict";

require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = CookiesDetailDialog;
var React = _interopRequireWildcard(require("react"));
var _Button = _interopRequireDefault(require("@mui/material/Button"));
var _Dialog = _interopRequireDefault(require("@mui/material/Dialog"));
var _DialogActions = _interopRequireDefault(require("@mui/material/DialogActions"));
var _DialogContent = _interopRequireDefault(require("@mui/material/DialogContent"));
var _DialogContentText = _interopRequireDefault(require("@mui/material/DialogContentText"));
var _Box = _interopRequireDefault(require("@mui/material/Box"));
var _Link = _interopRequireDefault(require("@mui/material/Link"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function CookiesDetailDialog(props) {
  const {
    open,
    setOpen,
    t,
    agreeToCookies
  } = props;
  const handleClose = () => {
    setOpen(false);
  };
  return /*#__PURE__*/React.createElement(_Dialog.default, {
    open: open,
    onClose: handleClose,
    "aria-labelledby": "dialog-rgpd-details",
    "aria-describedby": "dialog-rgpd-all-details"
  }, /*#__PURE__*/React.createElement(_DialogContent.default, null, /*#__PURE__*/React.createElement(_DialogContentText.default, {
    id: "alert-dialog-rgpd"
  }, t('rgpd.our_message', {
    joinArrays: ''
  })), /*#__PURE__*/React.createElement(_DialogContentText.default, {
    sx: {
      mt: 3
    }
  }, t('rgpd.cnil_info'), /*#__PURE__*/React.createElement(_Link.default, {
    href: "https://www.cnil.fr/fr/cookies-et-autres-traceurs",
    color: "#335C67"
  }, t('rgpd.cnil_site'))), /*#__PURE__*/React.createElement(_DialogContentText.default, {
    sx: {
      mt: 3,
      whiteSpace: 'pre-line'
    }
  }, t('rgpd.trackers', {
    joinArrays: '\n'
  })), /*#__PURE__*/React.createElement(_DialogContentText.default, {
    sx: {
      mt: 3
    }
  }, t('rgpd.browser')), /*#__PURE__*/React.createElement(_DialogContentText.default, {
    sx: {
      mt: 1
    }
  }, t('rgpd.browser_instructions')), /*#__PURE__*/React.createElement(_Box.default, {
    sx: {
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'wrap',
      gap: 1
    }
  }, /*#__PURE__*/React.createElement(_Link.default, {
    href: "https://support.google.com/accounts/answer/61416?hl=fr",
    color: "#335C67"
  }, "Chrome"), /*#__PURE__*/React.createElement(_Link.default, {
    href: "https://support.mozilla.org/fr/kb/activer-desactiver-cookies",
    color: "#335C67"
  }, "Firefox"), /*#__PURE__*/React.createElement(_Link.default, {
    href: "http://windows.microsoft.com/fr-fr/internet-explorer/delete-manage-cookies",
    color: "#335C67"
  }, "Internet Explorer"), /*#__PURE__*/React.createElement(_Link.default, {
    href: "https://help.opera.com/en/latest/web-preferences/#cookies",
    color: "#335C67"
  }, "Opera"), /*#__PURE__*/React.createElement(_Link.default, {
    href: "https://support.apple.com/fr-fr/guide/safari/sfri11471/mac",
    color: "#335C67"
  }, "Safari"))), /*#__PURE__*/React.createElement(_DialogActions.default, null, /*#__PURE__*/React.createElement(_Button.default, {
    size: "small",
    variant: "text",
    color: "primary",
    onClick: handleClose
  }, t('close')), /*#__PURE__*/React.createElement(_Button.default, {
    size: "small",
    variant: "contained",
    color: "primary",
    onClick: () => agreeToCookies()
  }, t('rgpd.agreed'))));
}